import { Fragment } from 'react';

import { useFormState } from 'react-final-form';

import { buildFlexibleDatesRequest } from '~/components/common/form/ExpandedDateFields/buildFlexibleDatesRequest';
import { WeddingDateFormFields } from '~/components/common/form/WeddingDateField/types';
import {
  FlexibleDateContent,
  ExactDateContent,
} from '~/components/inquiries/ExpandedWeddingDates/ExpandedWeddingDates';
import { hasFlexibleDates, hasExactDates } from '~/util/weddingDates';

export const ExpandedWeddingDateSummaryView = () => {
  const { values } = useFormState<WeddingDateFormFields>();
  const weddingDates = buildFlexibleDatesRequest(values);
  if (weddingDates) {
    if (hasFlexibleDates(weddingDates)) {
      return <FlexibleDateContent weddingDates={weddingDates} />;
    }
    if (hasExactDates(weddingDates, 1)) {
      return <ExactDateContent weddingDates={weddingDates} />;
    }
  }

  return <Fragment>No Selection</Fragment>;
};
